module.exports = __webpack_public_path__ + "static/img/cangpin1.83ff53a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cangpin1.png
// module id = JGUi
// module chunks = 26